import { createApp } from 'vue';
import RegistrationRoleSelect from './../components/register/RegistrationRoleSelect';
import BootstrapVueNext from 'bootstrap-vue-next'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

if (document.getElementById('register-app')) {
    const app = createApp({
        components: {
            'registration-role-select': RegistrationRoleSelect
        }
      });
    
    app.use(BootstrapVueNext);
    app.mount('#register-app');
}
